/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage200,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage401,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage500,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParams,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage.ts";

export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParamsSchema =
  z.object({
    discountTypeId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage200Schema =
  z.number() as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage500>;

export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse>;
